export default "<div class=\"row row-map\">\n    <div class=\"col-sm-12 no-padding\" id=\"map\" #map></div>\n</div>\n"